import { MANIFESTO } from "@/data/site";
import { Reveal, MaskLineInView } from "@/components/site/Reveal";

export const Manifesto = () => (
  <section className="bg-background py-24 md:py-32" data-testid="manifesto">
    <div className="mx-auto max-w-[1400px] px-6 md:px-8">
      <Reveal>
        <span className="text-xs tracking-[0.35em] uppercase text-muted-foreground">Why Heavy Duty</span>
      </Reveal>
      <h2 className="font-display uppercase tracking-tighter leading-[0.9] text-4xl sm:text-5xl md:text-6xl mt-5 max-w-3xl">
        <MaskLineInView>Built for the</MaskLineInView>
        <MaskLineInView delay={0.08} className="text-muted-foreground">road warriors.</MaskLineInView>
      </h2>

      <div className="mt-16 md:mt-24 grid gap-px bg-border border border-border">
        {MANIFESTO.map((m, i) => (
          <Reveal key={m.n} delay={i * 0.08}>
            <div className="bg-background grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 p-8 md:p-12 items-start">
              <div className="md:col-span-3">
                <span className="font-display text-6xl md:text-7xl leading-none text-outline">{m.n}</span>
              </div>
              <h3 className="md:col-span-4 font-display uppercase tracking-tight text-2xl md:text-3xl leading-tight">
                {m.title}
              </h3>
              <p className="md:col-span-5 text-muted-foreground text-base md:text-lg">{m.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
